document.addEventListener('DOMContentLoaded', function () {

  /* ── ANNOUNCEMENT BAR ROTATION ── */
  var announceItems = document.querySelectorAll('.fomo-announce-item');
  if (announceItems.length > 1) {
    var announceIndex = 0;
    setInterval(function () {
      announceItems[announceIndex].classList.remove('fomo-announce-active');
      announceIndex = (announceIndex + 1) % announceItems.length;
      announceItems[announceIndex].classList.add('fomo-announce-active');
    }, 4000);
  }



  /* ── VIEWING COUNTER ── */
  var viewEl = document.querySelector('.fomo-viewing-count');
  if (viewEl) {
    var base = Math.floor(Math.random() * 18) + 7;
    viewEl.textContent = base;
    setInterval(function () {
      var current = parseInt(viewEl.textContent);
      var change = Math.random() > 0.5 ? 1 : -1;
      viewEl.textContent = Math.max(5, Math.min(32, current + change));
    }, 5000);
  }

  /* ── CART TIMER ── */
  var cartTimerEl = document.getElementById('fomo-cart-timer');
  if (cartTimerEl) {
    var cartEnd = new Date(Date.now() + 12 * 60 * 1000); // 12 min from page load
    function tickCart() {
      var diff = cartEnd - Date.now();
      if (diff <= 0) { cartTimerEl.textContent = 'Sale ended'; return; }
      var m = String(Math.floor(diff / 60000)).padStart(2, '0');
      var s = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
      cartTimerEl.textContent = m + ':' + s;
    }
    tickCart();
    setInterval(tickCart, 1000);
  }

  /* ── SAME-DAY DISPATCH COUNTDOWN (counts down to the 4 PM cutoff) ── */
  var timerEl = document.getElementById('fomo-timer');
  if (timerEl) {
    function tick() {
      var now = new Date();
      var end = new Date();
      end.setHours(16, 0, 0, 0); // 4:00 PM cutoff
      // Past today's cutoff → count toward tomorrow's 4 PM window.
      if (end - now <= 0) { end.setDate(end.getDate() + 1); }
      var diff = end - now;
      var h = String(Math.floor(diff / 3600000)).padStart(2, '0');
      var m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
      var s = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
      timerEl.textContent = h + ':' + m + ':' + s;
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ── LOW STOCK: sync to the currently selected variant ──
     On a product page, a variant change only morphs the <variant-picker> and
     dispatches `variant:update`, whose detail.data.html is the full page
     re-rendered for the newly selected variant. We pull our freshly rendered
     low-stock block out of that HTML (real per-variant inventory, server truth)
     and swap it into the live DOM. Switches on both colour and size. */
  document.addEventListener('variant:update', function (event) {
    var html = event.detail && event.detail.data && event.detail.data.html;
    if (!html) return;
    var live = document.getElementById('fomo-stock-wrap');
    var fresh = html.querySelector('#fomo-stock-wrap');
    if (live && fresh) {
      live.innerHTML = fresh.innerHTML;
    }
  });

  /* ── RECENT PURCHASE POPUP ── */
  var popup = document.getElementById('fomo-popup');
  if (popup) {
    var names  = ['Nour', 'Mariam', 'Farah', 'Yasmin', 'Salma', 'Dina', 'Rania', 'Heba', 'Aya', 'Sara', 'Mona', 'Nada'];
    var cities = ['Cairo', 'Alexandria', 'Giza', 'Sharm El-Sheikh', 'Hurghada', 'Luxor', 'Aswan', 'Port Said', 'Mansoura', 'Tanta', 'Ismailia', 'Zagazig', 'Suez', 'Damietta', 'Assiut'];
    var items  = (window.fomoProducts && window.fomoProducts.length) ? window.fomoProducts : ['our latest dress'];
    var times  = ['just now', '2 mins ago', '4 mins ago', '7 mins ago', '10 mins ago'];

    function rand(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

    function showPopup() {
      popup.querySelector('.fomo-popup-name').textContent = rand(names) + ' from ' + rand(cities);
      popup.querySelector('.fomo-popup-item').textContent = 'just bought the ' + rand(items);
      popup.querySelector('.fomo-popup-time').textContent = rand(times);
      popup.classList.add('fomo-show');
      setTimeout(function () { popup.classList.remove('fomo-show'); }, 5000);
    }

    setTimeout(showPopup, 4000);
    setInterval(showPopup, 16000);

    var closeBtn = popup.querySelector('.fomo-popup-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        popup.classList.remove('fomo-show');
      });
    }
  }

});
